export default __webpack_public_path__ + "static/media/facebook.aad59f72.svg";